import { render } from "./Suite.vue?vue&type=template&id=7c58725d&scoped=true"
import script from "./Suite.vue?vue&type=script&lang=js"
export * from "./Suite.vue?vue&type=script&lang=js"

import "./Suite.vue?vue&type=style&index=0&id=7c58725d&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c58725d"]])

export default __exports__